var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Smock_LinkedIn_24_N",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Canvas",
    width: 18,
    height: 18,
    fill: "#ff13dc",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_178406",
    "data-name": "Path 178406",
    d: "M16.14,2H3.127A1.115,1.115,0,0,0,2,3.1V16.168a1.115,1.115,0,0,0,1.127,1.1H16.14a1.118,1.118,0,0,0,1.13-1.1V3.1A1.117,1.117,0,0,0,16.14,2ZM6.529,15.011H4.264V7.726H6.529ZM5.4,6.728A1.313,1.313,0,1,1,6.709,5.415,1.313,1.313,0,0,1,5.4,6.728Zm9.615,8.283H12.748V11.467c0-.845-.015-1.932-1.177-1.932-1.179,0-1.36.921-1.36,1.871v3.6H7.949V7.726h2.172v.993h.031a2.381,2.381,0,0,1,2.143-1.177c2.29,0,2.716,1.509,2.716,3.471Z",
    transform: "translate(-0.473 -0.473)",
    fill: "#222"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.c44cc8d81dc104105602f8b95a7da5cd.svg";
export { ForwardRef as ReactComponent };